import React from "react";
import "./banner.scss";
import Typed from "react-typed";

const Banner = () => {

  const string = ['Feel Good Food', 'Grocery Shopping', 'Vegetables 100% Organic' ]
  return (
    <>
      <section className="banner">
        <div className="container-fluid banner-blur">
                    <h2 className="text-center"><Typed
                    className="typed-text" 
                    strings={string}
                    typeSpeed={40}
                    backSpeed={60}
                    loop
                /></h2>
                    <h4>Shop all quality food</h4>
                    <button className="btn btn-dark-blue">Shop now</button>
        </div>
      </section>
    </>
  );
};

export default Banner;
